<div class="dialog-container">
    <div class="dialog-title">{{ data.title }}</div>
    <div class="dialog-message">{{ data.message }} <strong>{{ data.entityName }}</strong></div>
    <div class="dialog-buttons">
        <button mat-button class="cancel" (click)="onCancel()">{{'recordsManagement.delete.cancel' | transloco}}</button>
        <button mat-button class="confirm" (click)="onConfirm()">{{'recordsManagement.delete.confirm' | transloco}}</button>
    </div>
  </div>
